var Feedback = {};

Feedback.FILE_TYPES = ['image/png', 'image/bmp', 'image/jpeg', 'image/tiff', 'image/gif', 'image/svg+xml'];
Feedback.API_HOST = global_vars.api_host;
Feedback.ATTACHMENT = '';

Feedback.events = {

	init: function() {
		Feedback.events.bindEvents();
		Feedback.events.resetForms();
	},

	bindEvents: function() {
		var SELF = Feedback.events;
		var $feedbackModalForm = $('#modal-feedback-form');

		$feedbackModalForm.on('change', '#file-upload', SELF.onFileUpload);
		$feedbackModalForm.on('click', '#submit-feedback-btn', SELF.onClickSubmitButton);
		$feedbackModalForm.on('click', '#cancel-feedback-btn', SELF.onClickCancelButton);
		

		$("#marucci-feedback").click(SELF.onFeedback);
	},

	onFeedback: function() {
		UIkit.modal('#modal-feedback-form').show();
	},

	resetForms: function() {
		var $feedbackForm = $("#feedback-form");
		// reset form
		$feedbackForm[0].reset();
		// reset parsley validation
		$feedbackForm.parsley().reset();
	},

	onClickCancelButton: function() {
		Feedback.events.resetForms();
		UIkit.modal("#modal-feedback-form").hide();
	},

	onClickSubmitButton: function() {
		var $feedbackForm = $("#feedback-form").parsley();
		var isFeedbackValidated = $feedbackForm.isValid();

		if (!isFeedbackValidated) {
			$feedbackForm.validate();
			return undefined;
		}

		if (isFeedbackValidated) {
			var data = Feedback.funcs.getFeedbackData();
			Feedback.funcs.uploadFeedback(data, function(response) {
				if (response.success) {
					var message = response.message;
	            	UIkit.notification({message: message, status: 'success', pos: 'top-right'});

					UIkit.modal('#modal-feedback-form').hide();
				}
			});
			return undefined;
		}
	},

	onFileUpload: function() {
		var file = this.files[0];

        if (_.contains(Feedback.FILE_TYPES, file.type)) {
            Feedback.funcs.uploadImage(file, function(response){
                if (response.success) {
                    $('#file-upload-src')[0].src = response.filename;

                    Feedback.ATTACHMENT = response.filename;
                }
            });
        } else {
        	var message = "Please upload a valid image.";
            UIkit.notification({message: message, status: 'danger', pos: 'top-right'});
        }

        Feedback.ATTACHMENT = "";
	}
}

Feedback.funcs = {
	uploadImage: function(file, callback, errorCallback) {
        var formData = new FormData();
        formData.append('file', file);

        $.ajax({
            data: formData,
            url: Feedback.API_HOST + "/api/fileUpload",
            type: "POST",
            processData: false,
            contentType: false,
            crossDomain: true,
            headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            success: callback,
            error: errorCallback
        });
    },

    uploadFeedback: function(data, callback, errorCallback) {
    	var data = JSON.stringify(data);

    	$.ajax({
    		data: data,
            url: Feedback.API_HOST + "/api/feedback",
            type: "POST",
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": atob(global_vars.headerValue)},
            success: callback,
            error: errorCallback
        });
    },

    getFeedbackData: function() {
		var $feedbackForm = $("#feedback-form");

		return {
			"subject" : "Feedback",
			type: "feedback",
			order_code: "",
            content:  $feedbackForm.find("#message").val(),
            name: $feedbackForm.find("#name").val(),
            email: $feedbackForm.find("#email").val(),
            material_id: $feedbackForm.find("#material-id").val(),
            saved_design_id: $feedbackForm.find("#saved-design-id").val(),
            screenshot: Feedback.ATTACHMENT,
            brand: "marucci"
		};
	},

}

$(document).ready(Feedback.events.init);
